import {
    SET_ZONE_OPTIONS,
    SET_ALL_ZONES,
    SET_ZONE_PARKING_ASSISTANT_SETTINGS,
    UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS,
    type ZoneState,
} from 'src/redux/zone/zone.types'
import { type ZoneAction } from 'src/redux/zone/zone.actions'

export const INITIAL_STATE: ZoneState = {
    zoneOptions: [],
    allZones: [],
    zoneParkingAssistantSettings: null,
}

export function zoneReducer(state: ZoneState = INITIAL_STATE, action: ZoneAction): ZoneState {
    switch (action.type) {
        case SET_ZONE_OPTIONS:
            return { ...state, zoneOptions: action.payload }

        case SET_ALL_ZONES:
            return { ...state, allZones: action.payload }

        case SET_ZONE_PARKING_ASSISTANT_SETTINGS:
            return {
                ...state,
                zoneParkingAssistantSettings: action.payload,
            }

        case UPDATE_ZONE_PARKING_ASSISTANT_SETTINGS:
            return {
                ...state,
                zoneParkingAssistantSettings: action.payload,
            }

        default:
            return state
    }
}
